export default "__VITE_ASSET__DW0y0pg0__"